import { render, staticRenderFns } from "./CariSelect.vue?vue&type=template&id=2323d4b3&scoped=true"
import script from "./CariSelect.vue?vue&type=script&lang=js"
export * from "./CariSelect.vue?vue&type=script&lang=js"
import style0 from "./CariSelect.vue?vue&type=style&index=0&id=2323d4b3&prod&lang=css"
import style1 from "./CariSelect.vue?vue&type=style&index=1&id=2323d4b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323d4b3",
  null
  
)

export default component.exports